import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

/**
 * Get user's channels
 */
export const getChannels = async () => {
  const response = await axios.get(`${API_URL}/chat/channels`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  });
  return response.data;
};

/**
 * Create a new channel
 */
export const createChannel = async ({ name, description, type = 'public' }) => {
  const response = await axios.post(
    `${API_URL}/chat/channels`,
    { name, description, type },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    }
  );
  return response.data;
};

/**
 * Get channel messages
 */
export const getChannelMessages = async (channelId, limit = 50) => {
  const response = await axios.get(
    `${API_URL}/chat/channels/${channelId}/messages?limit=${limit}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    }
  );
  return response.data;
};

/**
 * Get channel members
 */
export const getChannelMembers = async (channelId) => {
  const response = await axios.get(
    `${API_URL}/chat/channels/${channelId}/members`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    }
  );
  return response.data;
};

/**
 * Add user to channel
 */
export const addUserToChannel = async (channelId, userId, role = 'member') => {
  const response = await axios.post(
    `${API_URL}/chat/channels/${channelId}/members`,
    { userId, role },
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    }
  );
  return response.data;
};

/**
 * Remove user from channel
 */
export const removeUserFromChannel = async (channelId, userId) => {
  const response = await axios.delete(
    `${API_URL}/chat/channels/${channelId}/members/${userId}`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    }
  );
  return response.data;
};

/**
 * Get user status
 */
export const getUserStatus = async (userId) => {
  const response = await axios.get(
    `${API_URL}/chat/users/${userId}/status`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    }
  );
  return response.data;
};

/**
 * Upload file
 */
export const uploadFile = async (file, onProgress) => {
  const formData = new FormData();
  formData.append('file', file);

  const response = await axios.post(
    `${API_URL}/chat/upload`,
    formData,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress: (progressEvent) => {
        if (onProgress) {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          onProgress(percentCompleted);
        }
      }
    }
  );
  return response.data;
};
